/** Presentation only. Never use this module to calculate or persist amounts. */
export const DEFAULT_MONETARY_DECIMAL_PLACES = 2;
export const MONETARY_DECIMAL_PLACES = [0, 1, 2, 3, 4, 5, 6] as const;

export function monetaryDecimalPlaces(value: unknown): number {
  return typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= 6
    ? value : DEFAULT_MONETARY_DECIMAL_PLACES;
}

export type MoneyPresentation = { locale?: string; monetaryDecimalPlaces?: number };

export function createMoneyFormatter(preferences: MoneyPresentation = {}, style: "currency" | "decimal" = "currency") {
  const digits = monetaryDecimalPlaces(preferences.monetaryDecimalPlaces);
  const options: Intl.NumberFormatOptions = {
    style, ...(style === "currency" ? { currency: "COP" } : {}),
    minimumFractionDigits: digits, maximumFractionDigits: digits,
  };
  let formatter: Intl.NumberFormat;
  try { formatter = new Intl.NumberFormat(preferences.locale ?? "es-CO", options); }
  catch { formatter = new Intl.NumberFormat("es-CO", options); }
  return (amount: number | null | undefined): string => {
    if (amount == null) return "—";
    if (!Number.isFinite(amount)) return "—";
    return formatter.format(amount);
  };
}
